import { createApp } from 'vue';
import App from './App.vue'
import router from './router/router.js';
import { store } from '@/store/store';
import moment from 'moment';
import { i18n } from './i18n/i18n-config.js'
import filters from './filters/filter';
import Antd from 'ant-design-vue';
import './assets/main.scss';
import { installPlugin } from './globalPlugin';
import { installComponents } from './globalPluginComponents';

// import { quillEditor } from 'vue3-quill';
const app = createApp(App);
// app.use(quillEditor)
app.use(installPlugin)
app.use(installComponents)
app.use(Antd);
app.use(moment);

app.use(router);
app.use(store);
app.use(i18n);
app.use(filters);

app.mount('#app');
document.title = "Testek admin";